<c11n-modal-dialog
  #otpVerificationModal
  id="otpVerificationModal"
  modalId="otpVerification"
  [headingText]="content.content">
  <div c11n-modal-dialog-body>
    <div evidence-id="otpModal" class="c11n-modal-dialog__content__buttons">
      <c11n-button id='otp-confirm-button' [labelText]="content.confirm" (clickEvent)='confirm()' variant="secondary"></c11n-button>
      <c11n-button id='otp-not-applicable-button' [labelText]="content.notApplicable" (clickEvent)='notApplicable()'></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
